import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import DynamicInputList from '../../software-dynamic-version-2/list-input';
import SecurityService from '../../security/security.service';
import AccessoryOpeningAdd  from './accessory-opening-add'
import AccessoryOpeningService from './accessory-opening.service';
import './accessory-opening.scss'


const AccessoryOpeningInput = (props) => {


//  AccessoryOpeningID	OpeningDate	GodownName	GodownID	OpeningQuantity	OpeningAmount
// AccessoryOpeningID	OpeningDate	GodownName	GodownID	CustomerOrderNo	InternalOrderNo	ExportOrderNo	FullAccessoryName	AccessoryID	
// Color	ColorID	AccessoryType	AccessoryTypeID	OpeningQuantity	OpeningRate	OpeningAmount	Unit	Seq

    let columns =[
        {  field: "AccessoryOpeningID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
        {  field: "OpeningDate",headerText:'Date',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "GodownName",headerText:'Godown Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "CustomerOrderNo",headerText:'Customer Order No.',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "InternalOrderNo",headerText:'Int. Order No.',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "FullAccessoryName",headerText:'Accessory Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "Unit",headerText:'Unit',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "Color",headerText:'Color',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "AccessoryType",headerText:'Accessory Type',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "OpeningQuantity",headerText:'Opening Qty',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{format:'n2'}]},
        {  field: "OpeningRate",headerText:'Opening Rate',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{format:'n2'}]},
        {  field: "OpeningAmount",headerText:'Opening Amount',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{format:'n0'}]},
        ]

       const listActionComplete = async (grid , args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          // if(args.requestType == 'add'){
          //   setTimeout(()=>document.getElementById('BrandGridBrandName').focus(),400)
          // }
          // document.getElementById('BrandGridBrandName').addEventListener('blur', async (e)=>{
          //   setTimeout(() => document.getElementById('BrandGridBrandName') && grid?.endEdit(), 200);
           
          // })
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            AccessoryID:args.data.AccessoryID,
            AccessoryTypeID:args.data.AccessoryTypeID,
            ColorID:args.data.ColorID,
            AccessoryName:args.data.AccessoryName,
            UnitID:args.data.UnitID
          }
          console.log(data)
        if(args.action == 'add'){
          AccessoryOpeningService.insert(data).then(async (res)=>{
            await getListService()
            // setTimeout(()=>document.getElementById('BrandGrid_add').click(),700)

            // let AddData = {
            //   BrandID:args.data.BrandID,
            //   BrandName:args.data.BrandName,
            // }
            // AuditTableInput.auditAdd(`Brand`,`Brand`,`BrandID`,AddData)
          })
        }
        if(args.action == 'edit'){
          AccessoryOpeningService.update(data).then((res)=>{
            getListService()

            // let EditData = {
            //     BrandID:args.data.BrandID,
            //     BrandName:args.data.BrandName
            // }
            // let totalColumns = Object.keys(EditData);
            //             console.log(totalColumns)
            //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`Brand`,args.data.MainBrandID)
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Brand${typeMode} 
        let ListSecurity='Accessory Opening'
        let AddSecurity='Accessory Opening'
        let EditSecurity='Accessory Opening'
        let DeleteSecurity='Accessory Opening'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions =['Add','Edit','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'];

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Brand' ,
                    TableID:'BrandID',
                   // Optional if Delete is Soft // TableSecurity:'BrandDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Brand' ,TableID:'BrandID', Optional // TableSecurity:'BrandDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='AccessoryOpening'
        ListTitle='Accessory Opening Detail - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> FullYarnCountInfoService.getBrandForList()
                        DataSource:  ()=> AccessoryOpeningService.getAccessoryOpeningForList({
                              FromDate:'01-JAN-24'                     
                              ,ToDate:moment().format('DD-MMM-YY')
                              ,ReportType:'Detail'
                              ,GodownID:0
                              ,AccessoryContractID:0
                              ,ExportOrderNo:0
                              ,AccessoryID:0
                              ,ColorID:0
                              ,AccessoryTypeID:0
                              ,PrintedByUserID:0

                        })
                        }]}
        DefaultSortedColumnName={'AccessoryOpeningID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<AccessoryOpeningAdd GridID={'AccessoryOpening'} />
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default AccessoryOpeningInput;
